import ApiArticleCategory from 'types/api/ArticleCategory';
import { ApiResources } from 'types/apiResources';
import { Endpoints, ListParamsDefault } from 'types/endpoints';
import ListCollection from 'types/redux/ListCollection';

import ArticleCategory from 'models/ArticleCategory';

import { LIST_MARKUP } from 'consts/redux';
import { withVariables } from 'utils/string';
import { request } from 'services/Api';

export interface ListParams extends ListParamsDefault {
    enabled?: boolean;
}
export const list = async (params?: ListParams): Promise<ListCollection<ArticleCategory>> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicArticleCategories, params),
        requestParams: params,
    });

    const data = response?.payload?.data;
    const resource = data && data[ApiResources.ArticleCategories];

    if(!data || !resource) {
        throw new Error('Not Found');
    }

    return {
        ...LIST_MARKUP,
        isLoaded: true,
        elements: resource
            .elements
            .map((element: ApiArticleCategory) => new ArticleCategory(element)),
        meta: resource.meta,
    };
};
